module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"months":"{count} месяцев | {count} месяц | {count} месяца | {count} месяцев","text":"Изменение платежного периода повлияет на следующие списания","nextPayment":"Следующий платеж","total":"Итого ","save":"Сохранить","cancel":"Отмена"}}')
  delete Component.options._Ctor
}
